<template>
	<v-dialog
    persistent
    fullscreen
    v-model="avatarParamentro.editar"
  >
    <v-card style="border-radius: 0px;">
      <v-card-title class="text-h5">
      	<v-spacer></v-spacer>
        <avataaars
        	height="200px"
        	:accessoriesType="avatar.accessoriesType"
        	:isCircle="avatar.isCircle"
		      :clotheType="avatar.clotheType"
        	:clotheColor="avatar.clotheColor"
		      :eyebrowType="avatar.eyebrowType"
		      :eyeType="avatar.eyeType"
		      :facialHairColor="avatar.facialHairColor"
        	:facialHairType="avatar.facialHairType"
		      :graphicType="avatar.graphicType"
		      :mouthType="avatar.mouthType"
        	:skinColor="avatar.skinColor"
        	:topType="avatar.topType"
        	:topColor="avatar.topColor"
		      :hairColor="avatar.hairColor"
		      :circleColor="'#6fb8e0'">
		    </avataaars>
      	<v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
      	<v-radio-group
		      v-model="avatar.isCircle"
		      row
		    >
		      <v-radio
		        label="Con fondo"
		        :value="true"
		      ></v-radio>
		      <v-radio
		        label="Sin fondo"
		        :value="false"
		      ></v-radio>
		    </v-radio-group>

		    <v-row>
				  <!-- Seleccionar el tono de piel -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="skinColorSelect"
				      v-model="avatar.skinColor"
				      label="Piel"
				    ></v-select>
		    	</v-col>

		    	<!-- Seleccionar el tipo de ojos que se quiere -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="eyeTypeSelect"
				      v-model="avatar.eyeType"
				      label="Tipo de ojos"
				    ></v-select>
		    	</v-col>

			    <!-- Seleccionar el tipo de rostro -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="eyebrowTypeSelect"
				      v-model="avatar.eyebrowType"
				      label="Tipo de rostro"
				    ></v-select>
		    	</v-col>

			    <!-- Seleccionar la boca -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="mouthTypeSelect"
				      v-model="avatar.mouthType"
				      label="Boca"
				    ></v-select>
		    	</v-col>

			    <!-- Seleccionar el cort de pelo -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="topTypeSelect"
				      v-model="avatar.topType"
				      label="Corte de cabello"
				    ></v-select>
		    	</v-col>

		    	<!-- color del cabello -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="hairColorSelect"
				      v-model="avatar.hairColor"
				      label="Color de cabello"
				    ></v-select>
		    	</v-col>

		    	<!-- Tono del accesorio de la cabez -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="topColorSelect"
				      v-model="avatar.topColor"
				      label="Color de accesorio cabeza"
				    ></v-select>
		    	</v-col>

		    	<!-- bello facial -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="facialHairTypeSelect"
				      v-model="avatar.facialHairType"
				      label="Tipo de bello facial"
				    ></v-select>
		    	</v-col>

		    	<!-- Color del bello facial -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="facialHairColorSelect"
				      v-model="avatar.facialHairColor"
				      label="Color bello facial"
				    ></v-select>
		    	</v-col>

		    	<!-- Accesorio del rostro -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="accessoriesTypeSelect"
				      v-model="avatar.accessoriesType"
				      label="Lentes"
				    ></v-select>
		    	</v-col>

		    	<!-- Seleccionar ropa -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="clotheTypeSelect"
				      v-model="avatar.clotheType"
				      label="Playera"
				    ></v-select>
		    	</v-col>

		    	<!-- Seleccionar estampado -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="graphicTypeSelect"
				      v-model="avatar.graphicType"
				      label="Estampa playera"
				    ></v-select>
		    	</v-col>

		    	<!-- tono de ropa -->
		    	<v-col cols="6">
				    <v-select
				    	filled
				    	dense
				    	hide-details
				      :items="clotheColorSelect"
				      v-model="avatar.clotheColor"
				      label="Color Playera"
				    ></v-select>
		    	</v-col>
		    </v-row>

      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          rounded
          small
          @click="avatarParamentro.editar = false"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          rounded
          small
          @click="validarUsuario()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>

    
    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

  </v-dialog>
</template>
<script>
	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'
	import Avataaars from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  export default {
  	props:[
			'avatarParamentro'
	  ],

  	components:{
  		Alerta,
  		Avataaars,
  	},

    data: () => ({
    	// Avatar
      accessoriesTypeSelect:['Blank','Kurt','Prescription01','Prescription02','Round','Sunglasses','Wayfarers'],
			clotheTypeSelect:['BlazerShirt','BlazerSweater','CollarSweater','GraphicShirt','Hoodie','Overall','ShirtCrewNeck','ShirtScoopNeck','ShirtVNeck'],
      clotheColorSelect:['Black','Blue01','Blue02','Blue03','Gray01','Gray02','Heather','PastelBlue','PastelGreen','PastelOrange','PastelRed','PastelYellow','Pink','Red','White'],
      eyebrowTypeSelect:['Angry','AngryNatural','Default','DefaultNatural','FlatNatural','RaisedExcited','RaisedExcitedNatural','SadConcerned','SadConcernedNatural','UnibrowNatural','UpDown','UpDownNatural'],
      eyeTypeSelect:['Close','Cry','Default','Dizzy','EyeRoll','Happy','Hearts','Side','Squint','Surprised','Wink','WinkWacky'],
      facialHairColorSelect:['Auburn','Black','Blonde','BlondeGolden','Brown','BrownDark','PastelPink','Platinum','Red','SilverGray'],
      facialHairTypeSelect:['Blank','BeardMedium','BeardLight','BeardMagestic','MoustacheFancy','MoustacheMagnum'],
      graphicTypeSelect:['Bat','Cumbia','Deer','Diamond','Hola','Pizza','Resist','Selena','Bear','SkullOutline','Skull'],
      hairColorSelect:['Auburn','Black','Blonde','BlondeGolden','Brown','BrownDark','PastelPink','Platinum','Red','SilverGray'],
      mouthTypeSelect:['Concerned','Default','Disbelief','Eating','Grimace','Sad','ScreamOpen','Serious','Smile','Tongue','Twinkle','Vomit'],
      skinColorSelect:['Tanned','Yellow','Pale','Light','Brown','DarkBrown','Black'],
      topTypeSelect:['NoHair','Eyepatch','Hat','Hijab','Turban','WinterHat1','WinterHat2','WinterHat3','WinterHat4','LongHairBigHair','LongHairBob','LongHairBun','LongHairCurly','LongHairCurvy','LongHairDreads','LongHairFrida','LongHairFro','LongHairFroBand','LongHairNotTooLong','LongHairShavedSides','LongHairMiaWallace','LongHairStraight','LongHairStraight2','LongHairStraightStrand','ShortHairDreads01','ShortHairDreads02','ShortHairFrizzle','ShortHairShaggyMullet','ShortHairShortCurly','ShortHairShortFlat','ShortHairShortRound','ShortHairShortWaved','ShortHairSides','ShortHairTheCaesar','ShortHairTheCaesarSidePart'],
      topColorSelect: ['Black','Blue01','Blue02','Blue03','Gray01','Gray02','Heather','PastelBlue','PastelGreen','PastelOrange','PastelRed','PastelYellow','Pink','Red','White'],
	    
	    dialogEditAvatar: false,

			avatar: {
				isCircle: true,
	      accessoriesType:null,
	      clotheType:null,
	      clotheColor:null,
	      eyebrowType: null,
	      eyeType: null,
	      facialHairColor:null,
	      facialHairType:null,
	      graphicType: null,
	      hairColor:null,
	      mouthType:null,
	      skinColor:null,
	      topType:null,
	      topColor:null,
	      circleColor:'#6fb8e0'
			},

			respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},


    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS', 'getAvatar']),
    },

    created () {
    	if( this.getAvatar != null ){
    		this.avatar = this.getAvatar
    	}
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario', 'grabarAvatar' ]),

    	habilitarVentana ( ventana ){
    		this.ventana = ventana
    	},

      validarDatos () {
        return this.$refs.form.validate()
      },

      validarUsuario (){
      	this.avatar['id_alumno'] = this.getUsuarioLMS.id
      	this.$http.put('usuario.update.avatar', this.avatar).then( response => {
      		this.grabarAvatar( response.body )
      		this.parametros.mensaje = response.body.message
    			this.parametros.dialogError    = true 
    			this.parametros.color          = 'success'
    			this.respuestaAlerta           = true 
    			this.avatarParamentro.editar = false
      	}).catch( error => {
      		if( error.status == 400 || error.status == 500){
      			this.parametros.mensaje      = error.body.message
      			this.parametros.dialogError  = true 
      			this.parametros.color        = '#FF2C2C' 
      			this.respuestaAlerta         = true 
      		}
      	})
    	}
    },
  }
</script>